import { Email } from '../Common/Email';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import { useContext, useState, useEffect, useMemo } from 'react';
import { InputTaxComponent } from '../InputTaxComponent/InputTaxComponent';
import { PayButton } from '../PaymentInputs/PayButton';
import { useVenmoBraintree } from '@/hooks/useVenmoBraintree';
import { isCountryCodeIsUSAOrCanada } from '@/utils/tax';
import { shouldHideEmail } from '@/utils/conditionalRendering';
import { isEmailValid } from '@/utils/email';
import { getPaymentKey } from '@/utils/getPaymentKey';

export const VenmoPayForm = () => {
  const {
    customer,
    actions: { setIsFormValid },
    paymentKeys,
    paymentMethodsSettings,
    featureFlags,
    template,
  } = useContext(CheckoutContext);
  const braintreeMethod = paymentMethodsSettings.find(
    (pm) => pm.provider === ProviderEnum.BRAINTREE && pm.paymentMethodName === PaymentMethodEnum.VENMO
  );
  const [isAddressValid, setIsAddressValid] = useState(
    isCountryCodeIsUSAOrCanada(customer?.geoLocator?.countryCode2 ?? customer.taxCountry ?? '') ? false : true
  );
  const braintreePK = useMemo(
    () =>
      getPaymentKey(braintreeMethod?.pspSubMidPk, paymentKeys.braintree, {
        provider: ProviderEnum.BRAINTREE,
        paymentMethod: PaymentMethodEnum.VENMO,
      }) || '',
    [braintreeMethod?.pspSubMidPk, paymentKeys.braintree]
  );
  const { handleSubmit } = useVenmoBraintree({ braintreePK });

  // Update global form validity
  useEffect(() => {
    const isFormValid = isEmailValid(customer?.email) && isAddressValid;
    setIsFormValid(isFormValid);
  }, [customer?.email, isAddressValid, setIsFormValid]);

  const handleValidate = (isValid: boolean) => {
    setIsAddressValid(isValid);
  };

  const handlePayment = async () => {
    await handleSubmit();
  };

  return (
    <div className="flex flex-col gap-4">
      {!shouldHideEmail(featureFlags, customer, template.features) && <Email />}
      <InputTaxComponent onValidate={handleValidate} />
      <PayButton isDisabled={!isEmailValid(customer?.email) || !isAddressValid} onClick={handlePayment} />
    </div>
  );
};
